import type { IRouteTicket } from './types.js';

/**
 * Gibt die Service-Dauer in Minuten für ein Ticket zurück
 * Priorisiert individuelle serviceDurationSeconds, falls vorhanden
 */
export function getTicketDurationMinutes(ticket: IRouteTicket): number {
  // Wenn individuelle Service-Dauer gesetzt ist, verwende diese
  if (ticket.serviceDurationSeconds && typeof ticket.serviceDurationSeconds === 'number') {
    return ticket.serviceDurationSeconds / 60;
  }

  // Ansonsten: Standard-Dauer basierend auf Ticket-Type
  switch (ticket.type) {
    case 'Enterprise':
      return 70;
    case 'HES':
      return 120;
    default:
      return 35;
  }
}
